// removed by extract-text-webpack-plugin
module.exports = {"root":"form--root--1O2TH1os","actions":"form--actions--2NCw3iTy","left":"form--left--3E7dtQW6","right":"form--right--1JNQxMWv","errors":"form--errors--32FOiqll"};


//////////////////
// WEBPACK FOOTER
// ./components/forms/form/styles.css
// module id = ./components/forms/form/styles.css
// module chunks = 0